import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "MyTrumpf/Partial Templates/Password Confirmation",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = () => {
    return html` <div class="ux-row">
        <div class="ux-col-10 ux-u-offset-1 ux-u-mt-s">
            <ux-form>
                <form id="form" action="#" mothod="POST">
                    <div class="ux-u-mb-xs">
                        <ux-password-input
                            required
                            id="old-password"
                            name="old-password"
                            label="Old password"
                            placeholder="Placeholder"
                            data-validation-required--msg="Please enter your old password here."
                        ></ux-password-input>
                    </div>
                    <div class="ux-u-mb-xs">
                        <ux-password-input
                            required
                            id="passwordvalidate"
                            name="password"
                            label="Password"
                            placeholder="Placeholder"
                            data-validation-required--msg="Please check all acceptance criteria"
                            has-acceptance-criteria
                            tooltip-headline="Passwortrichtlinien:"
                            check-length-text="8 Zeichen"
                            check-special-chars-text="1 Sonderzeichen"
                            check-uppercase-text="1 Großbuchstabe"
                            check-number-text="1 Zahl"
                        ></ux-password-input>
                    </div>
                    <div class="ux-u-mb-xs">
                        <ux-password-input
                            required
                            id="password-confirm"
                            name="password-confirm"
                            label="Confirm Password"
                            placeholder="Placeholder"
                            data-validation-required--msg="Password must match"
                            confirm-password-for="passwordvalidate"
                        ></ux-password-input>
                    </div>
                    <button
                        class="ux-button ux-button--green ux-u-mt-xxxs"
                        type="submit"
                    >
                        Submit
                    </button>
                </form>
            </ux-form>
        </div>
    </div>`;
};

export const Default = Template.bind({});

const InAsyncTabsTemplate = () => {
    return html` <div>
        <ux-tab-container>
            <ux-iws-async-tab
                name="New password confirmation"
                tab-id="npc"
                url="./mock-data/new-password-confirmation/new-password-confirmation.html"
                class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
            >
            </ux-iws-async-tab>
        </ux-tab-container>
    </div>`;
};

export const InAsyncTabs = InAsyncTabsTemplate.bind({});
